import { useFormik } from "formik";
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useReactToPrint } from 'react-to-print';
import { Container, Form } from 'reactstrap';
import * as Yup from "yup";
import logolight from "../../../assets/images/holcimlogoAdipi.png";
import Table1 from "../../../components/Common/TableContainer";
import { getQuotations } from "../../../store/catalogs/Quotations/actions";
import { getLabRequestQuotes } from "../../../store/labCitec/labRequestQuotations/actions";

export const QuotationsPrint = (props) => {
  const dispatch = useDispatch();
  let tot = 0

  useEffect(() => {
    dispatch(getQuotations("?limit=100&page=0"))
    dispatch(getLabRequestQuotes(`/?limit=20&page=0&labRequest=${props.location.pathname.split('/')?.slice(-1)[0]?.toString()}`))
    // }, [dispatch, props.location.pathname])
  }, [])

  const { labRequestQuotes, quotations, labRequest } = useSelector(state => ({
    labRequestQuotes: state.labRequestSurveyQuotesReducer.labRequestQuotes,
    quotations: state.quotationsReducer.quotations,
    labRequest: state.labRequestReducer.labRequest,
  }), shallowEqual);

  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
  const labRequestId = props.match?.params.id
  const [subTotal, setSubTotal] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [ivaCost, setIvaCost] = useState(0);

  useEffect(() => {
    if (labRequestQuotes.length > 0) {
      let tot = 0;
      labRequestQuotes[0]?.labRequestQuotationTest?.forEach((element) => {
        tot += element.totalPrice;
      });
      setSubTotal(tot);
      setIvaCost(tot * 0.16);
      setTotalCost(tot * 1.16);
    }
  }, [labRequestQuotes])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      customer: labRequestQuotes[0]?.customer ?? '',
      contactPhone: labRequestQuotes[0]?.contactPhone ?? '',
      attention: labRequestQuotes[0]?.attention ?? '',
      address: labRequestQuotes[0]?.address ?? '',
      justification: labRequestQuotes[0]?.justification ?? 'De acuerdo con su amable solicitud, nos es grato presentarle con usted el siguiente presupuesto para realizar los ensayos de laboratorio, solicitados para:',
      quotationResponsible: labRequestQuotes[0]?.quotationResponsible ?? '',
      quotationResponsiblePosition: labRequestQuotes[0]?.quotationResponsiblePosition ?? '',
    },
    validationSchema: Yup.object({
      justification: Yup.string().required("Justificación es un campo obligatorio"),
      contactPhone: Yup.string().matches(phoneRegExp, 'Ingrese numero teléfonico válido').required("Teléfono es un campo obligatorio"),
      customer: Yup.string().required("Cliente es un campo obligatorio"),
      address: Yup.string().required("Domicilio es un campo obligatorio"),
      attention: Yup.string().required("Campo obligatorio"),
    }),
    onSubmit: (values, { resetForm }) => {
      const updVal = {
        ...values,
        labRequest: labRequestId,
      }

      let tot = 0
      setTimeout(() => {
        labRequestQuotes[0]?.labRequestQuotationTest?.forEach(element => {
          tot = tot + element.totalPrice
        });

        setSubTotal(tot)
        setIvaCost(tot * 0.16)
        setTotalCost(tot * 1.16)
      }, 2800)
    }
  });

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true
  });

  const columns1 = React.useMemo(
    () => [
      {
        Header: 'Norma',
        width: '23%',
        Cell: ({ row }) => (
          <div>
            <div className='text-start' style={{ fontSize: '12px' }}>{row.original?.labRequestTest?.labTest?.norm?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Ensayo',
        width: '23%',
        Cell: ({ row }) => (
          <div>
            <div className='text-start' style={{ fontSize: '12px' }}>{row.original?.labRequestTest?.labTest?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Cantidad',
        width: '12%',
        Cell: ({ row }) => (
          <div>
            <div className='text-right' style={{ fontSize: '12px' }}>{` ${row.original?.quantity ?? '-'}`}</div>
          </div>
        ),
      },
      {
        Header: 'Precio Unitario',
        width: '12%',
        Cell: ({ row }) => (
          <div>
            <div className='text-right' style={{ fontSize: '12px' }}>{`$ ${row.original?.unitPrice?.toLocaleString('en-US', { maximumFractionDigits: 2 }) ?? '-'}`}</div>
          </div>
        ),
      },
      {
        Header: 'Importe',
        width: '12%',
        Cell: ({ row }) => (
          <div>
            <div className='text-right' style={{ fontSize: '12px' }}>{`$ ${row.original?.totalPrice?.toLocaleString('en-US', { maximumFractionDigits: 2 }) ?? '-'}`}</div>
          </div>
        ),
      },
    ],
    []
  )

  const columns2 = React.useMemo(
    () => [
      {
        Header: 'Notas',
        width: '100%',
        Cell: ({ row }) => (
          <div>
            <div className='text-start' style={{ fontSize: '11px' }}>{row.original.note ?? '-'}</div>
          </div>
        ),
      },
    ],
    []
  )

  const componentRef = useRef();

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex align-items-center justify-content-end mb-3">
            <button onClick={() => { handlePrint() }} className="btn btn-primary rounded-3 py-2 mx-4">
              <span className="mdi mdi-printer me-2"></span>Imprimir
            </button>
            <button onClick={() => { props.history.goBack() }} className="btn btn-success rounded-3 py-2">
              <span className="mdi mdi-keyboard-backspace me-2"></span>Atrás
            </button>
          </div>
          <Form
            className="form-horizontal mt-3 mb-1"
            onSubmit={(e) => {
              e.preventDefault();
              return false;
            }}
            ref={componentRef}
          >

            <div className='row'>
              <div className='col-md-8 col-sm-8 ml-2'>
                <div className='text text-gray mx-3 mt-2' style={{ fontSize: '12px', color: 'gray' }}>
                  <b>Holcim México Operaciones</b>
                </div>
                <div className='text text-gray mx-3' style={{ fontSize: '12px', color: 'gray' }}>
                  Tel: (01 722) 279 2900
                </div>
                <div className='text text-gray mx-3' style={{ fontSize: '12px', color: 'gray' }}>
                  Centro de Innovación Tecnológica para la Construcción
                </div>
                <div className='text text-gray mx-3' style={{ fontSize: '12px', color: 'gray' }}>
                  www.holcim.com.mx
                </div>
                <div className='text text-gray mx-3' style={{ fontSize: '12px', color: 'gray' }}>
                  Prol. Isidro Fabela Norte 1517
                </div>
                <div className='text text-gray mx-3' style={{ fontSize: '12px', color: 'gray' }}>
                  Col. San Juan de la Cruz
                </div>
                <div className='text text-gray mx-3' style={{ fontSize: '12px', color: 'gray' }}>
                  50010 Toluca, Estado de México
                </div>
              </div>
              <div className='col-md-4 col-sm-4'>
                <div className='d-flex align-items-center justify-content-middle mt-4'>
                  <div className='pt-4'>
                    <img src={logolight} alt="" height="48" className="logo logo-dark" />
                  </div>
                </div>
              </div>
            </div>
            <hr style={{ background: 'linear-gradient(to right, #94C12E,#04BBF1 ,#1D4370)', height: 4 }} />
            <div className='row'>
              <div className='col-12'>
                <div className="row mx-2">
                  <div className="text-primary col-3 col-md-4" style={{ fontSize: '13px', color: 'blue' }}>
                    <b>Folio: </b>&nbsp;
                    {labRequest.code}
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-4 col-md-4 col-sm-4'>
                    <div className='text-primary d-inline-flex py-2 mx-3 mb-1' style={{ fontSize: '13px', color: 'blue' }}>
                      <b>Asunto: </b>&nbsp;
                      <div> Cotización Ensayos Laboratorio - CITEC </div>
                    </div>
                  </div>
                  <div className='col-lg-4 col-md-4 col-sm-4'>
                    <div className='text-primary d-inline-flex py-2 mx-3 mb-1' style={{ fontSize: '13px', color: 'blue' }}>
                      <b>Ciudad de México a: </b>&nbsp;
                      <div> {moment().format('YYYY-MM-DD')} </div>
                    </div>
                  </div>
                  <div className='col-lg-4 col-md-4 col-sm-4'>
                    <div className='text-primary d-inline-flex py-2 mx-3 mb-1' style={{ fontSize: '13px', color: 'blue' }}>
                      <b>Estimado, cliente: </b>&nbsp;
                      <div> {validation.values.customer} </div>
                    </div>
                  </div>
                </div>
                <div className='row '>
                  <div className='col-lg-4 col-md-4 col-sm-4'>
                    <div className='text-primary d-inline-flex py-2 mx-3 mb-1' style={{ fontSize: '13px', color: 'blue' }}>
                      <b>Empresa: </b>&nbsp;
                      <div> Holcim México </div>
                    </div>
                  </div>
                  <div className='col-lg-4 col-md-4 col-sm-4'>
                    <div className='text-primary d-inline-flex py-2 mx-3 mb-1' style={{ fontSize: '13px', color: 'blue' }}>
                      <b>Teléfono de Contacto: </b>&nbsp;
                      <div> {validation.values.contactPhone} </div>
                    </div>
                  </div>
                  <div className='col-lg-4 col-md-4 col-sm-4'>
                    <div className='text-primary d-inline-flex py-2 mx-3 mb-1' style={{ fontSize: '13px', color: 'blue' }}>
                      <b>Atentamente: </b>&nbsp;
                      <div> {validation.values.attention} </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-6 col-md-6 col-sm-6'>
                    <div className='text-primary d-inline-flex py-2 mx-3 mb-1' style={{ fontSize: '13px', color: 'blue' }}>
                      <b>Segmento: </b>&nbsp;
                      <div> {labRequestQuotes[0]?.labRequest?.laboratorySegment?.name ?? '-'} </div>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-6 col-sm-6'>
                    <div className='text-primary d-inline-flex py-2 mx-3 mb-1' style={{ fontSize: '13px', color: 'blue' }}>
                      <b>Domicilio: </b>&nbsp;
                      <div> {validation.values.address} </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-12 col-md-12 col-sm-12'>
                    <div className='text-primary d-inline-flex py-2 mx-3 mb-1' style={{ fontSize: '13px', color: 'blue' }}>
                      <b>Justificación: </b>&nbsp;
                      <div> {validation.values.justification} </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h6 className='text-primary mt-3 mx-2'><u>Detalle de la Cotización</u></h6>
            <div className='mx-4'>
              <div className='mt-1'>
                <Table1 isAddTableBorderStrap columns={columns1} data={labRequestQuotes[0]?.labRequestQuotationTest ?? []} />
              </div>
              <div className="d-flex align-items-center justify-content-end mb-2" >
                <div className="px-3 py-1 mx-3 col-3 col-md-2" style={{ backgroundColor: '#1D4370', color: 'white', alignContent: 'center', alignItems: 'center', textAlign: 'center', fontSize: 13 }}>
                  <div>Subtotal</div>
                </div>
                <div className="text-center py-1 col-3 col-md-2" style={{ backgroundColor: '#1D4370', color: 'white', alignContent: 'center', alignItems: 'center', textAlign: 'center', fontSize: 13 }}>
                  <div>{`$ ${subTotal.toLocaleString('en-US', { maximumFractionDigits: 2 })}`}</div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end my-2">
                <div className="py-1 px-3 mx-3 col-3 col-md-2" style={{ backgroundColor: '#1D4370', color: 'white', alignContent: 'center', alignItems: 'center', textAlign: 'center', fontSize: 13 }}>
                  <div>16% de IVA</div>
                </div>
                <div className="py-1 text-center col-3 col-md-2" style={{ backgroundColor: '#1D4370', color: 'white', alignContent: 'center', alignItems: 'center', textAlign: 'center', fontSize: 13 }}>
                  <div>{`$ ${ivaCost.toLocaleString('en-US', { maximumFractionDigits: 2 })}`}</div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end mt-2">
                <div className="py-1 px-3 mx-3 col-3 col-md-2" style={{ backgroundColor: '#1D4370', color: 'white', alignContent: 'center', alignItems: 'center', textAlign: 'center', fontSize: 13 }}>
                  <div>Total</div>
                </div>
                <div className="py-1 text-center col-3 col-md-2" style={{ backgroundColor: '#1D4370', color: 'white', alignContent: 'center', alignItems: 'center', textAlign: 'center', fontSize: 13 }}>
                  <div>{`$ ${totalCost.toLocaleString('en-US', { maximumFractionDigits: 2 })}`}</div>
                </div>
              </div>

              <div className='mt-2'>
                <Table1 isAddTableBorderStrap columns={columns2} data={quotations} />
              </div>

              <div className='row'>
                <div className="row ml-2 mr-2 mb-2">
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <label className='text-primary ml-1'>Nombre:</label>
                    <div className='text-primary d-inline-flex py-2 mx-1' style={{ fontSize: '13px', color: 'blue' }}>
                      {validation.values.quotationResponsible}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <label className='text-primary ml-1'>Puesto:</label>
                    <div className='text-primary d-inline-flex py-2 mx-1' style={{ fontSize: '13px', color: 'blue' }}>
                      {validation.values.quotationResponsiblePosition}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Form>
        </Container>
      </div>
    </ React.Fragment>
  )
}